import {DictionaryObject} from "../../types/dictionary";
import protectedInstance from "../instances/protected";
import {AxiosResponse} from "axios";
import {PaginationResponse, Response} from "../../types/api";
import {ProductsObject} from "../../types/newAuction";
import {KatoObject, SingleKatoObject} from "../../types/newPlanItem";

async function searchEnstru(
    productType: DictionaryObject, searchText: string, page: number, pageSize: number
) {
    const query = `type=${productType.value}&q=${searchText}` +
        `&page=${page}&page_size=${pageSize}`;

    return protectedInstance
        .get(`/enstru/search?${query}`)
        .then((res: AxiosResponse<PaginationResponse<ProductsObject[]>>) => res.data)
}

async function searchKato(searchText: string, page: number, pageSize: number) {
    const query = `q=${searchText}` +
        `&page=${page}&page_size=${pageSize}`;

    return protectedInstance
        .get(`/kato/search?${query}`)
        .then((res: AxiosResponse<PaginationResponse<KatoObject[]>>) => res.data)
}

async function searchMkei(searchText: string, page: number, pageSize: number, enstruCode: string, lang: string = 'ru') {
    const query = `q=${searchText}` +
        `&page=${page}&page_size=${pageSize}&enstru_code=${enstruCode}`;

    return protectedInstance
        .get(`/mkei/search?${query}`, { headers: { "Accept-Language": lang }})
        .then((res: AxiosResponse<PaginationResponse<{id: number, label: string}[]>>) => res.data)
}

async function getKatoByCode(code: string, lang: string = 'ru') {
    return protectedInstance
        .get(`/kato/${code}`, {
            headers: {
                "Accept-Language": lang
            }
        })
        .then((res: AxiosResponse<Response<SingleKatoObject>>) => res.data)
}

async function getIntercom(lang: string = 'ru') {
    return protectedInstance
        .get(`/intercom`, {
            headers: {
                "Accept-Language": lang
            }
        }).then((res: AxiosResponse<Response<{id: number, label: string}[]>>) => res.data)
}

export const dictionaryService = {
    searchEnstru,
    searchKato,
    getKatoByCode,
    searchMkei,
    getIntercom
}